import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import ProductForm from './ProductForm';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import '../ManageUsers/ManageUser.scss';
import axios from 'axios';
import { ProductsLoader } from './ProductsLoader';
import { ROOT_API_URL } from '../../../../../api-config';
import { getColors, getSizes, getProductTypes } from '../../../../../Redux/Actions/CommonActions';
import { connect } from 'react-redux';
import { auth } from '../../../../../services/auth.service';
import { Alert } from 'reactstrap';

const FileDownload = require('js-file-download');

class ManageProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            prodoctInEdit: {},
            isPopupVisible: false,
            products: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Title", dir: "asc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    componentDidMount() {
        this.props.getColors();
        this.props.getSizes();
        this.props.getProductTypes();
    }

    dataStateChange = (e) => {

        if (e.data && e.data.filter && e.data.filter.filters) {
            var filters = e.data.filter.filters;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].field && (filters[i].field == "PriceDollars" || filters[i].field == "DiscountDollars")) {
                    var operator = filters[i].operator;

                    if (!filters[i].value && (operator == "lt" || operator == "lte" || operator == "gt" || operator == "gte")) {

                        filters[i].value = 0;

                    }

                } else if (filters[i].value == null) {
                    filters[i].value = "";
                }
            }
        }

        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (productsFetched) => {
        this.setState({
            ...this.state,
            products: productsFetched,
            isLoading: false
        });

        if (productsFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (productsFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        axios
            .get(`${ROOT_API_URL}/ManageProducts/GetColorsAndSizesForProduct?productId=${dataItem.ProductId}`, { headers: auth.authHeader() })
            .then((response) => {
                var colorOptions = [];
                var sizeOptions = [];
                for (var i = 0; i < response.data.colors.length; i++) {
                    var c = {
                        colorOptionId: response.data.colors[i].colorOptionId,
                        description: response.data.colors[i].description
                    }
                    colorOptions.push(c);
                }
                for (var i = 0; i < response.data.sizes.length; i++) {
                    var s = {
                        sizeOptionId: response.data.sizes[i].sizeOptionId,
                        description: response.data.sizes[i].description
                    }
                    sizeOptions.push(s);
                }
                var inEdit = Object.assign({}, dataItem);
                inEdit.colors = colorOptions;
                inEdit.sizes = sizeOptions;
                inEdit.ProductType = { id: dataItem.ProductTypeId, name: dataItem.ProductType }
                this.setState({
                    productInEdit: inEdit,
                    isPopupVisible: true
                });
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the change.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    };

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };
                for (var key in t[i]) {
                    element[key] = element[key] + '';
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManageProducts/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Products.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    }

    toggleActive = (dataItem) => {
        var model = { ProductId: dataItem.ProductId }
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageProducts/DeleteProduct`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to delete the product.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    };

    addNew = () => {
        this.setState({
            isPopupVisible: true,
            productInEdit: {}
        });
    }

    save = (model) => {
        console.log(model);
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageProducts/SaveProduct`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the product.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"products-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading products" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.products.total}
                                {...this.state.dataState}
                                {...this.state.products}
                                onDataStateChange={this.dataStateChange}
                            >
                                <GridToolbar>
                                    <div className="admin-grid-toolbar-box2">
                                        <button onClick={this.addNew} className="admin-k-button">
                                            <i className="fas fa-plus-circle"></i>
                                            <span>ADD NEW</span>
                                        </button>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.edit, this.toggleActive)} />
                                <Column field="Title" title="Title" filter="text" />
                                <Column field="Description" title="Description" filter="text" />
                                <Column field="ProductType" title="Type" />
                                <Column field="Colors" title="Colors" filter="text" />
                                <Column field="Sizes" title="Sizes" filter="text" />
                                <Column field="PriceDollars" title="Price" className="align-cells-right" filter="numeric" format="{0:c2}" />
                                <Column field="DiscountDollars" title="Discounted Price" className="align-cells-right" filter="numeric" format="{0:c2}" />
                                <Column field="IsMemberOnly" title="Is Member Only" filterable={true} filter="boolean" />
                                <Column field="IsPublished" title="Is Published" filterable={true} filter="boolean" />
                                <Column
                                    field="IsActive"
                                    title="Is Active"
                                    width="150vw"
                                    filterable={true}
                                    filter="boolean"
                                />
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <ProductsLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <ProductForm
                                dataItem={this.state.productInEdit}
                                save={this.save}
                                cancel={this.cancel}
                            />
                        ) : ""
                    }
                </div>
            </div>

        );
    }
}
function mapStateToProps(state) {
    return {
        product: state.product,
        common: state.common
    };
}

export default connect(mapStateToProps, {
    getColors,
    getSizes,
    getProductTypes,
})(ManageProducts);
